import {
  DialogTrigger as AriaDialogTrigger,
  type DialogTriggerProps as AriaDialogTriggerProps,
} from 'react-aria-components';

interface PopoverTriggerProps extends AriaDialogTriggerProps {}

const PopoverTrigger = AriaDialogTrigger;

export type { PopoverTriggerProps };
export { PopoverTrigger };
